import * as $ from 'jquery';

export function initCollapseIcon() {
    $('.btn-collapse').off('click').on('click', function(){
        $(this).find('[data-fa-i2svg]').toggleClass('fa-angle-up fa-angle-down');
    });
}